import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css.global`
  .claim-damage-contents {
    width: 380px;
    padding: 16px;
    display: flex;
    flex-direction: column;
  }
  .claim-damage-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .claim-damage-row {
    margin-bottom: 8px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .readonly-row {
    margin-bottom: 8px;
  }
  .readonly-value {
    font-size: 13px;
    color: #6b6b6b;
    background: #f5f5f5;
    border-radius: 6px;
    padding: 8px 10px;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .button-container {
    padding: 8px 0;
  }
  .claim-damage-contents :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .claim-damage-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
